module.exports = "/_next/static/images/engineeringBanner-abf07be078e977d65e4b3cf1632d2c70.webp";